<template>
  <div :class="selectClass">
    <button type="button" class="btn_select" :class="isOpen ? 'on': ''" @click="toggleSelect">{{ selected }}</button>
    <ul class="select_list">
      <li v-for="option in options"><button @click="selectOption(option)">{{ option }}</button></li>
    </ul>
  </div>
  <span>{{ unit }}</span>
</template>

<script>

export default {
  props: {
    modelValue: String,
    options: Array,
    unit: String,
    selectClass: String
  },

  data () {
    return {
      isOpen: false,
    }
  },

  computed: {
    selected() {
      return this.modelValue
    }
  },

  methods: {
    toggleSelect() {
      this.isOpen = !this.isOpen
    },

    selectOption(option) {
      this.$emit("update:modelValue", option)
      this.isOpen = false
    },
  },
    
}
</script>

<style></style>